import { Button, H2 } from "@sellar-io/components";
import { Alert } from "../../../../../../../../components/alert/Alert";
import { DialogContent } from "../../../../../../../../components/modal/Dialog";
import { useFullPageDialogContext } from "../../../../../../../../components/modal/useFullPageDialogContext";

export const SellarCreditCheckNotEligible = () => {
  const { onDismiss } = useFullPageDialogContext();

  return (
    <>
      <DialogContent className="flex h-full items-center justify-center">
        <div className="flex flex-col items-center justify-center gap-2 text-center">
          <H2>
            Your company is not eligible for credit with Sellar Credit at this
            time
          </H2>
          <p>
            Unfortunately Two inc cannot offer your company trade credit at this
            time. But you can still set up your usual credit terms with
            suppliers directly on Sellar
          </p>

          <div className="text-left">
            <Alert
              type="success"
              title="Get credit terms with your suppliers"
              message=""
            >
              <p>
                Add them to your list to send a message to request your usual
                terms and pricing.
              </p>
            </Alert>
          </div>
          <div className="mt-6 flex w-full flex-col gap-2">
            <Button className="w-full" onClick={onDismiss}>
              Finish
            </Button>
            <Button
              color="secondary"
              className="w-full"
              onClick={() =>
                window.open(
                  "https://intercom.help/sellario/en/articles/10722487-buyer-guide-i-ve-been-declined-for-sellar-credit",
                  "_blank",
                )
              }
            >
              Learn more
            </Button>
          </div>
        </div>
      </DialogContent>
    </>
  );
};
